import { render } from "./MessageButtonsBar.vue?vue&type=template&id=7b2a76a2&scoped=true"
import script from "./MessageButtonsBar.vue?vue&type=script&lang=js"
export * from "./MessageButtonsBar.vue?vue&type=script&lang=js"

import "./MessageButtonsBar.vue?vue&type=style&index=0&id=7b2a76a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2a76a2"]])

export default __exports__